import { createStore } from "../reactive/store.js";
const transactionsByAddress = new Map();
/**
 * Retrieve the transaction store for a given address.
 * @param address - The address to retrieve the transaction store for.
 * @returns A store of transactions for the given account to subscribe to.
 * @transaction
 * @example
 * ```ts
 * import { getTransactionStore } from "thirdweb/transaction";
 *
 * const store = getTransactionStore("0x...");
 * store.subscribe((transactions) => {
 *   console.log(transactions);
 * });
 * ```
 */
export function getTransactionStore(address) {
    const existingStore = transactionsByAddress.get(address);
    if (existingStore) {
        return existingStore;
    }
    const newStore = createStore([]);
    transactionsByAddress.set(address, newStore);
    return newStore;
}
/**
 * @internal
 */
export function addTransactionToStore(options) {
    const { address, transactionHash, chainId } = options;
    const tranasctionStore = getTransactionStore(address);
    tranasctionStore.setValue([
        ...tranasctionStore.getValue(),
        { transactionHash, chainId },
    ]);
    transactionsByAddress.set(address, tranasctionStore);
}
//# sourceMappingURL=transaction-store.js.map